import { useMemo } from 'react'

import { Flex, Typography } from 'antd'

import { MemberPageItem } from '@eastcoal/api/auth/interface'
import { queryMemberPageApi } from '@eastcoal/api/auth/operationMember/queryMemberPage'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'

import { MemberRemoteSelectProps, MemberSelectProps } from './interface'

const resolveOptions = (value?: MemberPageItem[]) =>
  value?.map(item => ({
    label: item.name,
    value: item?.id,
    desc:
      item.agentName && item.agentPhone
        ? `（${item.agentName}: ${item.agentPhone}）`
        : '（无业务受托人）'
  }))

const getOptionValue = (value: MemberPageItem) => `${value.id}`

export const MemberSelect = ({
  mode,
  disabled,
  placeholder,
  value,
  onChange,
  /* ************************************************************************** */
  /*                                   业务参数                                  */
  /* ************************************************************************** */
  managerId,
  type,
  showAgentInOption = false
}: MemberSelectProps) => {
  const optionRender: MemberRemoteSelectProps['optionRender'] = useMemo(() => {
    return showAgentInOption
      ? option => {
          return (
            <Flex align='center' gap={0}>
              {option.data.label}
              <Typography.Text type='secondary'>
                {option.data.desc}
              </Typography.Text>
            </Flex>
          )
        }
      : undefined
  }, [showAgentInOption])

  return (
    <RemoteSelect
      allowClear
      api={queryMemberPageApi}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode={mode}
      optionRender={optionRender}
      placeholder={placeholder}
      refreshDeps={[managerId, type]}
      requestParams={{ all: true, type, managerId }}
      resolveOptions={resolveOptions}
      value={value}
      onChange={onChange}
    />
  )
}
